export const PAGES_PROTECTED_FOR_AUTHORIZED_USERS = ['/login', '/register', '/']

export const PAGES_RESET_PASSWORD_URL = ['/recovery-password', '/new-password']
export const LEGACY_PAGES_URL = ['/teasers', '/teasers_my', '/apps', '/blog']
export const LEGACY_CREATIVES_URL = ['/teasers', '/apps', '/teasers_my']
